import "../../../../styles/productViewItem.scss";

import Icon, { iconColor, iconTypes } from "../../../common/components/Icon";
import { addRemoveSalesUnitToClaim, clearClaim, getLastInvoiceForProduct } from "../../actions/history.js";
import { canWorkWithOrder, countAddedProduct, countWhat, getProductOrderProperty, getSalesLineId, usingCounterField } from "../../util/orderUtil.js";

import Accordion from "../../../common/components/Accordion.jsx";
import AddRemoveField from "../../../common/components/AddRemoveField.jsx";
import CounterField from "../../../common/components/CounterField.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import Modal from "../../../common/components/Modal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import { connect } from "react-redux";
import { downloadHmsPdf } from "../../util/productUtil.jsx";
import { withRouter } from "react-router-dom";

const mapStateToProps = () => {
    return (state) => ({
        token: state.authentication.token,
        lastInvoiceForProduct: state.history.lastInvoiceForProduct,
    });
};
const mapDispatchToProps = {
    downloadHmsPdf,
    getLastInvoiceForProduct,
    addRemoveSalesUnitToClaim,
    clearClaim,
};

// Component for displaying product details (popup window that is displayed when users clicks on a product in an item list)
class ProductViewModal extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            lastInvoice: null,
        };

        this.onClickPrintHms = this.onClickPrintHms.bind(this);
        this.onClickCreateClaim = this.onClickCreateClaim.bind(this);
        this.editMyList = this.editMyList.bind(this);
    }
    UNSAFE_componentWillMount() {
        const {
            getLastInvoiceForProduct,
            lastInvoiceForProduct,
            product,
        } = this.props;
        if( lastInvoiceForProduct[product.productId]===undefined ){
            getLastInvoiceForProduct(product.productId);
        }
    }
    onClickPrintHms(){
        this.props.downloadHmsPdf(this.props.token, this.props.product, false);
    }
    onClickCreateClaim(event){
        const {
            history,
            lastInvoiceForProduct,
            addRemoveSalesUnitToClaim,
            onCloseModal,
            product,
            clearClaim,
        } = this.props;
        if( lastInvoiceForProduct[product.productId]!=null ){
            clearClaim();
            addRemoveSalesUnitToClaim(product, 1);
            history.push(`/history/claim/${lastInvoiceForProduct[product.productId]}/invoice`);
            onCloseModal(event);
        }
    }

    editMyList(event)
    {
        const {
            onCloseModal,
            onMyListEdit,
        } = this.props;
        
        onMyListEdit();
        onCloseModal(event);
    }

    render(){
        const {
            localization,
            product,
            activeOrder,
            onCloseModal,
            onAddProductChange,
            width,
            salesLineId,
        } = this.props;

        let iconType = iconTypes.x;
        if( product.productStorageType=="Tørr" ) {
            iconType = iconTypes.box;
        } else if( product.productStorageType=="Frys" ) {
            iconType = iconTypes.snowflake;
        } else if( product.productStorageType=="Kjøl" ) {
            iconType = iconTypes.thermostat;
        }

        const salesLineIdTmp = salesLineId ? salesLineId : getSalesLineId(activeOrder, product.productId, true);

        const durabilityDesc = (product.durabilityDesc && product.durabilityDesc.length>0) ? product.durabilityDesc : "";
        const isKitMember = getProductOrderProperty(activeOrder, product.productId, "isKitMember", salesLineIdTmp);
        const isLocked = getProductOrderProperty(activeOrder, product.productId, "isLocked", salesLineIdTmp);
        const hasWarning = getProductOrderProperty(activeOrder, product.productId, "warningText")!=null;
        const orderErrorText =  getProductOrderProperty(activeOrder, product.productId, "errorText");
        const hasError = orderErrorText!=null || product.notActive;
        const canEdit = canWorkWithOrder(activeOrder) && !isLocked && !isKitMember;
        const isUsingCounterField = usingCounterField(activeOrder);
        const added = countAddedProduct(activeOrder, product.productId, countWhat.everything, salesLineIdTmp);
       
        const minValue = getProductOrderProperty(activeOrder, product.productId, "mustOrderAtLeastOne")?1:0;
        const isOpenDistribution = getProductOrderProperty(activeOrder, product.productId, "isOpenDistributionLine");
        
        return (
            <Modal onCloseModal={onCloseModal} width={width}>
                <div className="product-modal-wrapper">
                    <div className="product-modal-header">
                        <div className="header-content">
                            <div className="header-left">
                                <div className="header-detail">{localization.text("order","ProductDetail")}</div>
                                <div className="header-prd-name">{product.productName}</div>
                            </div>
                            <button className="btn circular" style={{float:"right"}} onClick={onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red}/>
                            </button>
                        </div>
                    </div>
                    <div className="product-modal-body">
                        <div className="product-modal-image-bg">
                            <img src={product.imageUrl} className="product-view-item-image" />
                            <div className="warning-wrapper">
                                {(isLocked || isKitMember) && (
                                    <div className="warning-bg">
                                        <Icon type={iconTypes.lockLocked} className="lock"/>
                                    </div>
                                )}
                                {isOpenDistribution && (
                                    <div className="warning-bg">
                                        <Icon type={iconTypes.lockUnlocked} className="lock"/>
                                    </div>
                                )}
                                {minValue===1 && (
                                    <div className="warning-bg">
                                        <Icon type={iconTypes.lockOneLocked} className="lock"/>
                                    </div>
                                )}
                                {hasWarning && (
                                    <div className="warning-bg">
                                        <Icon type={iconTypes.warningTiny} className="lock"/>
                                    </div>
                                )}
                                {hasError && (
                                    <div className="warning-bg">
                                        <Icon type={iconTypes.errorTiny} className="lock"/>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="product-modal-data">
                            <div className="product-modal-data-row">
                                <div className="product-modal-data-header">{localization.text("order","quantity")}</div>
                                <div className="product-modal-data-info">{localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}</div>
                            </div>
                            <div className="product-modal-data-row">
                                <div className="product-modal-data-header">{localization.text("order","productType")}</div>
                                
                                <div className="product-modal-data-info-icon">  
                                    <div className="tooltip">
                                        <Icon type={iconType} />
                                        <span className="tooltiptext">{product.productStorageType}</span>
                                    </div>
                                </div>
                                {product.flammable && (
                                    <div className="product-modal-data-info-icon-hazard">
                                        <div className="tooltip">
                                            <Icon type={iconTypes.flammable} />
                                            <span className="tooltiptext">{localization.text("order","flammable")}</span>
                                        </div>
                                    </div> 
                                )}
                                {product.poisonous && (
                                    <div className="product-modal-data-info-icon-hazard">
                                        <div className="tooltip">
                                            <Icon type={iconTypes.poisonous} />
                                            <span className="tooltiptext">{localization.text("order","poisonous")}</span>
                                        </div>
                                    </div>
                                )}
                                {product.healthHazard && (
                                    <div className="product-modal-data-info-icon-hazard">
                                        <div className="tooltip">
                                            <Icon type={iconTypes.healthHazard} />
                                            <span className="tooltiptext">{localization.text("order","healthHazard")}</span>
                                        </div>
                                    </div>
                                )}                               
                            </div>
                            <div className="product-modal-data-row">
                                <div className="product-modal-data-header">{localization.text("order","expiering")}</div>
                                <div className="product-modal-data-info">{durabilityDesc}</div>
                            </div>
                            <div className="product-modal-data-row bottom-border">
                                <div className="product-modal-data-header">{localization.text("order","epd")}</div>
                                <div className="product-modal-data-info">{product.epdNo}</div>
                            </div>
                            <div className="product-modal-data-row bottom-border">
                                <div className="product-modal-data-header">{localization.text("order","price")}</div>
                                <div className="product-modal-data-price" style={{ display: "flex" }}>
                                    { product.campaignDiscount && (
                                        <div className="product-modal-data-price-strikeThrough">{product.priceExCampaignDiscount.toFixed(2)}</div>
                                    )}
                                    <div>{`${product.price.toFixed(2)} ${product.hasDeposit ? "(+ pant)" : ""} `}</div>
                                </div>
                            </div>
                            <div className="product-modal-data-row bottom-border">
                                <div className="product-modal-data-header">{localization.text("chain", "detail", "epProductId")}</div>
                                <div className="product-modal-data-info">{product.productId}</div>
                            </div>
                            <div className="product-modal-data-row bottom-border">
                                <div className="product-modal-data-header">{localization.text("chain", "detail", "supplierName")}</div>
                                <div className="product-modal-data-info">{product.supplierName}</div>
                            </div>
                            <div className="product-modal-data-row bottom-border">
                                <div className="product-modal-data-header">{localization.text("chain", "detail", "category")}</div>
                                <div className="product-modal-data-info">{product.category}</div>
                            </div>
                            { product.usageForm && (
                                <div className="product-modal-data-row-accordion">
                                    <div className="product-modal-data-header">{localization.text("order", "usageForm")}</div>
                                    <Accordion label=""  >
                                        <div className="product-modal-data">{product.usageForm}</div>
                                    </Accordion>
                                </div> 
                            )}                                                      
                        </div>
                    </div>
                    {isKitMember && (
                        <div className="product-modal-warning">
                            <Icon type={iconTypes.lockLocked}/>
                            {localization.text("order","isKitMemberText")}
                        </div>
                    )}
                    {isLocked && (
                        <div className="product-modal-warning">
                            <Icon type={iconTypes.lockLocked}/>
                            {localization.text("order","isLockedText")}
                        </div>
                    )}
                    {isOpenDistribution && (
                        <div className="product-modal-warning">
                            <Icon type={iconTypes.lockUnlocked}/>
                            {localization.text("order","isUnlockedText")}
                        </div>
                    )}
                    {minValue===1 && (
                        <div className="product-modal-warning">
                            <Icon type={iconTypes.lockOneLocked}/>
                            {localization.text("order","isLocked1Text")}
                        </div>
                    )}
                    {hasError && (
                        <div className="product-modal-warning">
                            <Icon type={iconTypes.error}/>
                            {orderErrorText ? orderErrorText : product.notActiveText}
                            { product.notActive && (
                                <button className={"btn circular noselect"} style={{marginLeft: "auto"}} onClick={this.editMyList}>
                                    <Icon type={iconTypes.pen}/>
                                </button>
                            )}
                        </div>
                    )}
                    {hasWarning && (
                        <div className="product-modal-warning">
                            <Icon type={iconTypes.warning}/>
                            {getProductOrderProperty(activeOrder, product.productId, "warningText")}                          
                        </div>
                    )}
                    <div className="product-modal-footer">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={6}>
                                {product && product.hasHmsDataSheet && (
                                    <button className="btn" onClick={this.onClickPrintHms}>
                                        {localization.text("order","hms")}
                                    </button>
                                )}
                                {/* Uncomment this code if the want to create a claim from a product directly
                                {lastInvoiceForProduct[product.productId] && (
                                    <button className="btn" onClick={this.onClickCreateClaim}>
                                        {localization.text("order","createInvoice")}
                                    </button>
                                )} */}
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={6}>
                                { onAddProductChange && (
                                    <div className="product-modal-counter">
                                        { !product.notActive && (
                                            isUsingCounterField ? (
                                                <CounterField onEdit={onAddProductChange} value={added} salesLineId={salesLineIdTmp} disabled={!canEdit} minValue={minValue} activeOrder={activeOrder} product={product}/>
                                            ) : (
                                                <AddRemoveField onEdit={onAddProductChange} value={added} version={activeOrder.version} disabled={!canEdit}/>
                                            ))}
                                    </div>
                                )}                 
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            </Modal>
        );
    }
}
ProductViewModal.propTypes = {
    localization: Localization.propTypes.isRequired,
    product: PropTypes.object.isRequired,
    activeOrder: PropTypes.object.isRequired,
    onAddProductChange: PropTypes.func,
    onCloseModal: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    downloadHmsPdf: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    lastInvoiceForProduct: PropTypes.object.isRequired,
    getLastInvoiceForProduct: PropTypes.func.isRequired,
    addRemoveSalesUnitToClaim: PropTypes.func.isRequired,
    clearClaim: PropTypes.func.isRequired,
    onMyListEdit: PropTypes.func,
    salesLineId: PropTypes.number,
};

export default  withRouter(connect(mapStateToProps,mapDispatchToProps)(ProductViewModal));